module.exports = __webpack_public_path__ + "img/news-arrow.7c5c35bf.svg";